// Un plugin pour remplacer le spinner par défaut d'Element UI

export function injectTriDotsSpinner() {
  // Fonction exécutée après chaque création d'un spinner de chargement
  function setupCustomSpinner() {
    // Trouver tous les spinners Element UI
    const spinners = document.querySelectorAll('.el-loading-spinner');
    
    // Pour chaque spinner, vérifier s'il contient déjà notre spinner personnalisé
    spinners.forEach(spinner => {
      if (!spinner.querySelector('.tri-dots-container')) {
        // Créer le conteneur pour notre spinner
        const triDotsContainer = document.createElement('div');
        triDotsContainer.className = 'tri-dots-container';

        // Créer les dots
        for (let i = 1; i <= 3; i++) {
          const dot = document.createElement('div');
          dot.className = `tri-dot tri-dot-${i}`;
          triDotsContainer.appendChild(dot);
        }

        // Insérer notre spinner avant le texte
        const loadingText = spinner.querySelector('.el-loading-text');
        if (loadingText) {
          spinner.insertBefore(triDotsContainer, loadingText);
        } else {
          spinner.appendChild(triDotsContainer);
        }
      }
    });
  }

  // Observer le DOM pour détecter l'ajout de nouveaux spinners
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length) {
        setupCustomSpinner();
      }
    });
  });

  // Commencer à observer le document
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Configurer les spinners existants
  setupCustomSpinner();
}

export default {
  install(Vue) {
    Vue.prototype.$injectTriDotsSpinner = injectTriDotsSpinner;
    // Exécuter la fonction dès que Vue est monté
    Vue.nextTick(() => {
      injectTriDotsSpinner();
    });
  }
}; 